import {useEffect, useRef} from 'react'
import {Image} from '@primer/react-brand'

// Assets
import ImageMona from './_assets/mona.webp'
import ImageCopilot from './_assets/copilot.webp'
import ImageDucky from './_assets/ducky.webp'

import Styles from './Mascot.module.css'

// Mascot can be set to 'Mona', 'Copilot', or 'Ducky' in Contentful
// under Section > Hero Component > Content > Generic Content > ID

type Props = {
  mascot: string
  hideOnDesktop?: boolean
}

export function Mascot({mascot, hideOnDesktop}: Props) {
  const mascotRef = useRef<HTMLDivElement | null>(null)
  const getMascotImage = () => {
    switch (mascot) {
      case 'Mona':
        return ImageMona
      case 'Copilot':
        return ImageCopilot
      case 'Ducky':
        return ImageDucky
      default:
        return null
    }
  }

  useEffect(() => {
    if (!mascotRef.current) return
    const observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target)

            if (mascotRef.current) {
              mascotRef.current.classList.add(Styles.Animate)
            }
          }
        }
      },
      {threshold: 0.1},
    )
    observer.observe(mascotRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  const mascotImage = getMascotImage()

  // Don't render component if no valid mascot is found
  if (!mascotImage) {
    return null
  }

  return (
    <div className={Styles.Mascot} {...(hideOnDesktop && {'data-hide-on-desktop': true})} ref={mascotRef}>
      <div className={Styles.Shadow} />
      <Image className={Styles.Image} src={mascotImage} width={230} height={230} alt="" loading="lazy" />
    </div>
  )
}
